import CrudFacecade from './CrudFacecade.vue'
import CrudFacecadePag from './CrudFacecadePag.vue'
import DocumentEdit from './DocumentEdit.vue'
import CrudFacecadeTree from './CrudFacecadeTree.vue'
import FormDialog from './FormDialog.vue'
import FormDialog150 from './FormDialog150.vue'
import DateTimeInput from './DateTimeInput.vue'
import ListView from './ListView.vue'
import TextFormatter from './TextFormatter.vue'
import ItemInput from './ItemInput.vue'
import EditView from './EditView.vue'
import TreeDialog from './TreeDialog.vue'
import TreeTable from './TreeTable.vue'
import TreeTableNew from './TreeTableNew.vue'
import ListViewNesting from './ListViewNesting.vue'
import RouterMenu from './RouterMenu.vue'
import TreeMenu from './TreeMenu.vue'
import ScrollPane from './ScrollPane.vue'
import ItemGroup from './ItemGroup.vue'
import CusDialog from './CusDialog.vue'
import CusDialogNoDrag from './CusDialogNoDrag.vue'
import CusForm from './CusForm.vue'
import CusForm2 from './CusForm2.vue'
import CusForm150 from './CusForm150.vue'
import DocFrame from './DocFrame.vue'
import PrintButton from './PrintButton.vue'
import CusStep from './CusStep.vue'
import CloseButton from './CloseButton.vue'
import PdfFrame from './PdfFrame.vue'
import TextAreaDialog from './TextAreaDialog.vue'

const components = [
    CrudFacecade, DocumentEdit, CrudFacecadePag, CrudFacecadeTree, FormDialog, FormDialog150, DateTimeInput, ListView, TextFormatter, ItemInput, EditView, TreeDialog, TreeTable, TreeTableNew, ListViewNesting,
    RouterMenu, TreeMenu, ScrollPane, ItemGroup,
    CusDialog, CusDialogNoDrag, CusForm, CusForm2, CusForm150, DocFrame, PrintButton, CusStep, CloseButton, PdfFrame, TextAreaDialog
]

const install = function(Vue, opts = {}) {
    components.map(component => {
        Vue.component(component.name, component)
    })
}
// 这里的判断很重要
if (typeof window !== `undefined` && window.Vue) {
    // window.Vue.use(comment)
    install(window.Vue)
}

const isMobile = function() {
    // 判断是否是手机端，如果是，返回true
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Tablet|Symbian|Windows Phone)/i)
    let _isMobile = flag != null
    localStorage.setItem(`isMobile`, _isMobile)
    return _isMobile
}

export default {
    install,
    isMobile,
    CrudFacecade,
    CrudFacecadePag,
    CrudFacecadeTree,
    FormDialog,
    ListView,
    TextFormatter,
    ItemInput,
    EditView,
    TreeDialog,
    TreeTable,
    TreeTableNew,
    ListViewNesting,
    RouterMenu,
    TreeMenu,
    ScrollPane,
    ItemGroup,
    CusDialog,
    CusForm,
    DocFrame,
    PrintButton,
    CusStep,
    CloseButton,
    PdfFrame,
    TextAreaDialog
}



// WEBPACK FOOTER //
// ./src/common/index.js